import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    height: 440,
    padding: '0 8px',
    '@media (max-width: 960px)': {
      height: 'unset',
    },
  },
  image: {
    '@media (max-width: 960px)': {
      width: 160,
    },
  },
});

const EmptyContacts = ({ title, subtitle, img }) => {
  const classes = useStyles();
  return (
    <div className="flexContainer--center">
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid item xs={12} md={7} lg={7}>
          <Typography
            style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#10587f',
              lineHeight: 'normal',
            }}
          >
            {title}
          </Typography>
          <br />
          <Typography
            style={{
              fontSize: '18px',
              color: '#10587f',
            }}
          >
            {subtitle}
          </Typography>
        </Grid>
        <Grid item xs={12} md={3} lg={3}>
          <div style={{textAlign:'right'}}>
            <img className={classes.image} src={img} alt="" />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default EmptyContacts;
